import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from '../common/Loading.js';
import ErrorMessage from '../common/ErrorMessage.js';
import ArtistService from '../../services/artistService';
import ToastrService from '../../services/toastrService';
import urls from '../../constants/urls';
import * as audioUtils from '../../utils/audioUtils';
import * as qs from 'query-string';
import AccountService from '../../services/accountService';
import { withRouter, Redirect } from 'react-router-dom';
import MaterialInput from '../common/MaterialInput.js';
import { canUseDom } from '../../utils/browserCheck.js';

class EditHearMe extends React.Component {
    constructor(props, context) {
        super(props, context);      
        this.initialise = this.initialise.bind(this);
        this.editTrack = this.editTrack.bind(this);
        this.removeTrack = this.removeTrack.bind(this);
        this.uploadTrack = this.uploadTrack.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
        this.showUpload = this.showUpload.bind(this);
        this.closeShowUpload = this.closeShowUpload.bind(this);
        this.updateTrack = this.updateTrack.bind(this);   
        this.closeEditTrack = this.closeEditTrack.bind(this);
        this.updateSelectedTrackField = this.updateSelectedTrackField.bind(this);
        this.updateNewTrackField = this.updateNewTrackField.bind(this);
        this.connectToSoundCloud = this.connectToSoundCloud.bind(this);
        this.getExternalLogins = this.getExternalLogins.bind(this);
        this.loadSoundCloudTracks = this.loadSoundCloudTracks.bind(this);
        this.addTrack = this.addTrack.bind(this);
        const externalLoginLoading = this.checkForExternalLoginCallback();
        this.state = {
            profile: this.props.profile,
            externalLogins: [],
            tracks: [],
            tracksAvailable: [],
            loadingTracks: false,
            showUpload: false,
            uploadingTrack: false,
            selectedTrack: null,
            externalLoginLoading,
            newTrack: {}
        };
     }

    componentWillMount() {
        this.initialise();
        if(!this.state.externalLoginLoading) {
            this.getExternalLogins();
        }
        if(this.props.soundCloudToken) {
            this.loadSoundCloudTracks();
        }
    }

    componentDidMount() {  
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.profile.ID !== this.props.profile.ID) {
            this.setState({
                profile: nextProps.profile,
                tracks: [],
                selectedTrack: null
            }, this.initialise);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if((this.state.selectedTrack && !prevState.selectedTrack) || (this.state.showUpload && !prevState.showUpload)) {
            window.componentHandler.upgradeDom();  
        }        
        if(this.props.soundCloudToken && !prevProps.soundCloudToken) {
            this.loadSoundCloudTracks();
        }
    }

    initialise(clearProfileTracks = false) {
        this.setState({ loadingTracks: true, selectedTrack: null, error: null, uploadError: null, uploadingTrack: false });
        this.props.actions.getTracks(this.state.profile.ID)
            .then(tracks => {
                this.setState({ loadingTracks: false, tracks });
                if(clearProfileTracks) {
                    this.props.actions.clearProfileTracks(this.state.profile.ID);
                }
            })
            .catch(error => this.setState({ loadingTracks: false }));
    }

    editTrack(event, track) {
        event.preventDefault();
        this.setState({ selectedTrack: track, error: null, uploadError: null });
    }

    closeEditTrack(event) {
        event.preventDefault();
        this.initialise();
    }

    removeTrack(event, track) {
        event.preventDefault();
        if(confirm(`Remove track '${track.Name}' from your LoudUp page? This will delete any song ratings and play stats`)) {
            this.props.actions.deleteTrack(this.state.profile.ID, track.ID)
                .then(_ => {
                   this.initialise(true);
                   const toastrService = new ToastrService();
                    toastrService.showSuccess('', 'The track has been removed successfully');
                })
                .catch(error => {
                    this.setState({ error: 'Sorry, something went wrong, unable to delete track' });
                });
        }
        else {
            return false;
        }
    }

    uploadTrack(event) { 
        event.preventDefault();
        if(this.state.newTrack.Track) {
            this.setState({ uploadingTrack: true, error: null, uploadError: null });
            this.props.actions.uploadTrack(this.state.profile.ID, this.props.soundCloudToken, this.state.newTrack)
                .then(track => {
                    const tracks = [...this.state.tracks].concat(track);   
                    this.setState({ uploadingTrack: false, tracks, newTrack: { }, showUpload: false }, this.loadSoundCloudTracks);
                })
                .catch(error => {
                    this.setState({ uploadError: error.message, uploadingTrack: false });
                });
        }
        else {
            this.setState({uploadError: 'Please select a file to upload', error: null});
        }
        
    }

    showUpload(event) {
        event.preventDefault();
        this.setState({ showUpload: true });
    }

    closeShowUpload(event) {
        event.preventDefault();
        this.setState({ showUpload: false, newTrack: { }, error: null, uploadError: null });
    }

    onFileChange(event) {
        if(event.target.files.length) {
            audioUtils.readAudioFile(event, (upload, filename, trackLengthSecs) => {
                if(upload && upload.target.result) {
                    const file = upload.target.result.split(',')[1];
                    const newTrack = {...this.state.newTrack};
                    newTrack.Track = file;
                    newTrack.Filename = filename;
                    newTrack.TrackLengthSecs = trackLengthSecs;
                    this.setState({ newTrack, error: null });
                }
            }, (error) => {
                this.setState({error});
            }, 10);
        }
    }

    updateTrack(event) {
        event.preventDefault();
        const track = this.state.selectedTrack;
        this.props.actions.updateTrack(this.state.profile.ID, track.ID, track.Name, track.Description, track.Featured)
            .then(updatedTrack => {
                const toastrService = new ToastrService();
                toastrService.showSuccess('', 'The changes have been saved successfully');
                this.initialise(true);
            }) 
            .catch(error => {
                this.setState({ error: error.message, uploadingTrack: false });
            });
    }

    updateSelectedTrackField(event) {
        const name = event.target.name;
        const value = event.target.className === 'mdl-checkbox__input' ? event.target.checked : event.target.value;
        const selectedTrack = {...this.state.selectedTrack};
        selectedTrack[name] = value;
        this.setState({ selectedTrack });
    }

    updateNewTrackField(event) {
        const name = event.target.name;
        const value = event.target.className === 'mdl-checkbox__input' ? event.target.checked : event.target.value;
        const newTrack = {...this.state.newTrack};
        newTrack[name] = value;
        this.setState({ newTrack });
    }

    getExternalLogins() {
        if(!this.state.externalLogins.length) {
            //add a trailing slash after the url as otherwise, Safari will strip the oauth fragment added to the url after the #
            //actually it doesn't seem to work but we no longer need the fragment
            let pathname = window.location.pathname;
            if(pathname[pathname.length - 1] !== '/') {
                pathname = pathname + '/';
            }
            AccountService.getExternalLoginsList(pathname)
                .then(logins => {
                    //we've already redirected if the user is set
                    this.setState({
                        externalLogins: logins
                    });
                })
                .catch(error => {
                });
        }
    }

    connectToSoundCloud(event) {
        event.preventDefault();
        let login;
        if(this.state.externalLogins.length) {
            login = this.state.externalLogins.find(l => l.Name === 'SoundCloud');
        }
        if(login) {
            const apiUrl = urls.API_URL;
            window.location = `${login.Url}`;
        }  
    }

    checkForExternalLoginCallback() {
        let loading = false;
        const toastrService = new ToastrService();
        //if (browserCheck.canUseDom()) {
        const hash = this.props.location.hash;
        let params = {};
        if(hash) {
            params = qs.parse(hash.substr(1));
        }
        let accessTokenCookie = canUseDom() ? document.cookie
            .split('; ')
            .find(row => row.startsWith('AccessToken')) : null;
        let accessToken = accessTokenCookie ? accessTokenCookie.split('=')[1] : (params.access_token ? params.access_token : null);
        let expiresAtCookie = canUseDom() ? document.cookie
            .split('; ')
            .find(row => row.startsWith('ExpiresAt')) : null;
        let expires = expiresAtCookie ? decodeURIComponent(expiresAtCookie.split('=')[1]) : (params.expires_at ? params.expires_at : null);
        if(accessToken) {
            loading = true;
            //delete the token details from the cookie now we've read it (it's set to expire in 5 mins but let's be extra safe)
            const domain = window.location.hostname;
            document.cookie = `AccessToken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 UTC;Domain=${domain}`;
            document.cookie = `Expires=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 UTC;Domain=${domain}`;
            this.props.actions.saveSoundCloudToken(accessToken);
            //this is to get rid of the token in the url but we don't need it as we're using cookies now
            //window.history.replaceState(null, document.title, this.props.location.pathname + this.props.location.search);                
        }
        else if(params.error) {
            toastrService.showError('SoundCloud login failed', 'Sorry, something went wrong, unable to complete login');
        }
        //} 
        return loading;
    }

    loadSoundCloudTracks() {
        if(this.props.soundCloudToken) {
            this.props.actions.getSoundCloudTracks(this.props.soundCloudToken)
            .then(tracks => {
                this.setState({ tracksAvailable: tracks.map(t => t) });
            })
            .catch(error => this.setState({ loadingTracks: false }));
        }        
    }

    addTrack(event, track) {
        event.preventDefault();
        if(this.state.tracks.length >= 8) {
            this.setState({ error: 'You cannot upload more than 8 tracks' });
        }
        else {
            //test a track name with a '
            if(confirm(`Add track '${track.Name} to your LoudUp page?`)) {
                this.props.actions.addSoundCloudTrack(this.state.profile.ID, track.ID)
                .then(addedTrack => {
                    const tracks = [...this.state.tracks].concat(addedTrack);
                    this.setState({ tracks, error: null });
                    const toastrService = new ToastrService();
                    toastrService.showSuccess('', 'The track has been added successfully');
                    this.props.actions.clearProfileTracks(this.state.profile.ID);
                }) 
                .catch(error => {
                    this.setState({ error: error.message, uploadingTrack: false });
                });
            }
            else {
                return false;
            }
        }
    }

    render() {
        return (
            this.props.profile.RoleType === 'Fan' || !ArtistService.showMusic(this.props.profile.RoleType) ?
                <Redirect to="/Profile/Manage" />
                :
                !this.state.selectedTrack ? 
                    <div id="divCreateProfile">
                        <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                        {
                            !this.props.soundCloudToken ?
                                <React.Fragment>
                                    <p>Please log into SoundCloud to add your existing music to your LoudUp profile</p>
                                    <form id="frmSoundCloudConnect">
                                        <div>
                                            <a href="#" onClick={this.connectToSoundCloud}>
                                                <img src={require('../../images/btn-socialsign-sc.png')} alt="Connect to SoundCloud" />
                                            </a>
                                        </div>
                                    </form>
                                    <br />
                                    <p>Don't have a SoundCloud account? Click <a href="http://www.soundcloud.com" target="_blank">here</a> to register:</p>    
                                </React.Fragment>
                            : 
                                <React.Fragment>
                                    <p>You can add up to 8 tracks</p>     
                                    {
                                    !this.state.showUpload ?
                                            <a id="aUploadMusic" href="#" className="btn-simple transition" onClick={this.showUpload} style={{display:this.state.tracks.length < 8 ? 'inline' : 'none'}}>Upload a new track →</a>
                                        :
                                            <div className="form form-horizontal">
                                                <a href="#" style={{float:'right'}} onClick={this.closeShowUpload}>Close</a>
                                                <p style={{fontWeight:'bold', color: '#666'}}>Upload track to SoundCloud</p>
                                                <span style={{fontSize:'0.8em'}}>This will upload a track to your SoundCloud account and then add the track to your LoudUp page</span>
                                                <br />
                                                <form id="frmUploadMusic" onSubmit={this.uploadTrack} style={{padding: '15px 0'}}>
                                                    <ErrorMessage error={this.state.uploadError} onClose={() => this.setState({ uploadError: null })} />
                                                    <input type="file" id="File" name="File" onChange={this.onFileChange} accept="audio/*" />
                                                    <MaterialInput name="Name" value={this.state.newTrack.Name} onChange={this.updateNewTrackField} maxLength="35" required />
                                                    <MaterialInput name="Description" value={this.state.newTrack.Description} onChange={this.updateNewTrackField} maxLength="300" />
                                                    <div className="form-group">
                                                        <div className="col-sm-7 col-sm-push-3">
                                                            <input type="submit" value="Upload" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" style={{ marginRight: '5px' }} />{ this.state.uploadingTrack ? <Loading /> : null } 
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                    } 
                                    <div id="soundCloudTracks">
                                        <p className="formlegend">Music uploaded to SoundCloud <span style={{fontWeight:'normal', color:'#e55d1e'}}>(Click Add to add a track to your profile)</span></p>
                                        <div className="table-info visible-xs">&#8592; SCROLLABLE &#8594;</div>
                                        <div className="table-responsive">
                                            <table id="available" className="table table-striped table-results gig-listings">
                                                <thead>
                                                    <tr>
                                                        <th>&nbsp;</th>
                                                        <th>TITLE</th>
                                                        <th>DESCRIPTION</th>
                                                        <th>DURATION</th>
                                                        <th>SHARING</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.tracksAvailable.length ?
                                                            this.state.tracksAvailable.filter(t => {
                                                                const existingStreams = this.state.tracks.map(t => t.Path);
                                                                return !existingStreams.includes(t.StreamUrl);
                                                            }).map(track =>
                                                                <tr key={track.ID} className="transition">
                                                                    <td>
                                                                        {
                                                                            track.Sharing.toLowerCase() === 'public' ?
                                                                                <a href="#" className="btn-simple transition" onClick={(e) => this.addTrack(e, track)}>Add</a>
                                                                            :   <span style={{color: 'red'}}>Unable to add private tracks</span>
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        <a href={track.Url} target="_blank" className="transition">{track.Name}</a>
                                                                    </td>
                                                                    <td>
                                                                        {track.Description ? track.Description.substr(0, 300) : ''}
                                                                    </td>
                                                                    <td>
                                                                        {`${track.DurationMins}:${(track.DurationSecs + '').padStart(2, '0')}`}
                                                                    </td>
                                                                    <td>{track.Sharing}</td>
                                                                </tr>
                                                            )  
                                                        : 
                                                            <tr>
                                                                <td colSpan="5" style={{ textAlign: 'center' }}>No music available in your SoundCloud account</td>
                                                            </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </React.Fragment>                     
                        }
                        <br />
                        <div id="loudUpTracks">                        
                            <p className="formlegend">Music added to LoudUp</p>
                            <div className="table-info visible-xs">&#8592; SCROLLABLE &#8594;</div>
                            <div className="table-responsive">
                                <table id="uploaded" className="table table-striped table-results gig-listings">
                                    <thead>
                                        <tr>
                                            <th>NAME</th>
                                            <th>DESCRIPTION</th>
                                            <th>DURATION</th>
                                            <th>FEATURED</th>
                                            <th>UPLOADED</th>
                                            <th>&nbsp;</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.tracks.length ?
                                                this.state.tracks.map(track => 
                                                    <tr key={track.ID} className="transition">
                                                        <td>
                                                            {track.Name}
                                                        </td>
                                                        <td>
                                                            {track.Description}
                                                        </td>
                                                        <td>
                                                            {`${track.TrackLengthMins}:${(track.TrackLengthSecs + '').padStart(2, '0')}`}
                                                        </td>
                                                        <td>
                                                            <input type="checkbox" name="Featured" defaultChecked={track.Featured} disabled />
                                                        </td>
                                                        <td>{new Date(track.UploadDate).toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                                                        <td>
                                                            <a href="#" className="btn-simple transition" onClick={(e) => this.editTrack(e, track)}>Edit</a>
                                                        </td>
                                                        <td>
                                                            <a href="#" className="btn-simple transition" onClick={(e) => this.removeTrack(e, track)}>Remove</a>
                                                        </td>
                                                    </tr>   
                                                )                                            
                                            : 
                                            <tr>
                                                <td colSpan="7" style={{textAlign: 'center'}}>
                                                    {
                                                        this.state.loadingTracks ? 
                                                            <Loading /> 
                                                            : 'No music had been added to your LoudUp page yet'
                                                    }
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>   
                :            
                    <div id="editTrack" className="form form-block">
                        <a href="#" style={{float:'right'}} onClick={this.closeEditTrack}>Close</a>
                        <p style={{fontWeight: 'bold'}}>Edit Track Information</p>
                        <form id="frmEditTrack" className="form form-tightfields form-regular" onSubmit={this.updateTrack}>
                            <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                            <MaterialInput name="Name" value={this.state.selectedTrack.Name} onChange={this.updateSelectedTrackField} maxLength="35" />
                            <MaterialInput name="Description" value={this.state.selectedTrack.Description} onChange={this.updateSelectedTrackField} maxLength="300" />
                            { //check if this was the original featured track, if so, don't allow it to be deselected, we can only select a new featured track
                                !this.state.tracks.find(i => i.ID === this.state.selectedTrack.ID).Featured ?
                                <label className="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" htmlFor="Featured" style={{ paddingBottom: '25px' }}>
                                    <input type="checkbox" id="Featured" name="Featured" className="mdl-checkbox__input" defaultChecked={this.state.selectedTrack.Featured} onChange={this.updateSelectedTrackField} />
                                    <span className="mdl-checkbox__label">Set as featured track</span>
                                </label>
                                : null
                            }
                            <input type="submit" value="Save" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" />                   
                        </form>
                    </div>                
        );
    }
}

EditHearMe.propTypes = {
    profile: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    soundCloudToken: PropTypes.string,
    location: PropTypes.object
};

export default withRouter(EditHearMe);